import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from "vue-router";
import DefSearch from "@/components/DefSearch";
import DefVersion from "@/components/DefVersion";
import DefDiff from "@/components/DefDiff";

Vue.config.productionTip = false

const router = new VueRouter({
  routes: [{path: '/', component: DefDiff }, {path: '/search', component: DefSearch },{path: '/version', component: DefVersion }, ]
})

Vue.use(VueRouter)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
